import { DRFFacilityWrapper } from "../styles";
import { Button } from "@/common/components/button";
import { LargeCard } from "../../stats/subs/LargeCard";
import {
  FacilityDetailsTableHeaders,
  FacilityDetailsTableKeys,
  financialManagementCards,
  getFacilityDetails,
  getFacilityDetailsTableData,
} from "../data";
import { useNavigate } from "react-router-dom";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import useQuery from "@/hooks/useQuery";
import { useState } from "react";

const DRFFacility = () => {
  const navigate = useNavigate();
  const previousPage = "/dashboard/state-sec/financials/drf";
  const [facilityDetailsPerpage, setFacilityDetailsPerpage] = useState(10);
  const {
    data: facilityDetailsData,
    meta: facilityDetailsMeta,
    loading: facilityDetailsLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${facilityDetailsPerpage}&page=${facilityDetailsPerpage}`
  );

  const handleBack = () => {
    navigate(previousPage);
  };
  return (
    <DRFFacilityWrapper>
      <div className="button-section">
        <Button onClick={handleBack}>Back</Button>
        <Button secondary>Export</Button>
      </div>
      <div className="card-wrapper">
        {financialManagementCards?.map((card: any) => (
          <LargeCard
            color={card?.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>
      <div className="facility-section">
        <h1 className="title">DRF Facility Data</h1>
        <div className="facility-data">
          <div>
            <h3>Facility Name</h3>
            <p>{getFacilityDetails().name}</p>
          </div>
          <div>
            <h3>Current Balance</h3>
            <p>{getFacilityDetails().current_balance}</p>
          </div>
          <div>
            <h3>Last Allocation Date</h3>
            <p>{getFacilityDetails().last_allocation_date}</p>
          </div>
          <div>
            <h3>Last Allocation</h3>
            <p>{getFacilityDetails().last_allocation}</p>
          </div>
          <div>
            <h3>Current Request</h3>
            <p>{getFacilityDetails().current_request}</p>
          </div>
        </div>
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={FacilityDetailsTableHeaders}
          tableKeys={FacilityDetailsTableKeys}
          tableData={getFacilityDetailsTableData(facilityDetailsData)}
          tableTitle="DRF Enabled Facilities"
          loading={facilityDetailsLoading}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={facilityDetailsMeta?.total_pages}
          onNextPage={(event: any) => setFacilityDetailsPerpage(event.selected)}
          onPerPageChange={(event: any) =>
            setFacilityDetailsPerpage(event?.target?.value)
          }
        />
      </div>
    </DRFFacilityWrapper>
  );
};

export default DRFFacility;
